import React from "react";
import Select from "react-select";
import { Grid } from "@mui/material";

import { colors } from "../../../css components/Style";

export default function SortBy({ sortBy, setSortBy, setPage }) {
  let options = [
    { value: "", label: "All" },
    { value: "ACTIVE", label: "Active", color: colors.green },
    { value: "OFFER_ACCEPTED", label: "Accepted", color: colors.lightGreen },
    { value: "CREATED", label: "Created", color: colors.blue },
    { value: "REQUESTED", label: "Requested", color: colors.yellow },
    { value: "EXPIRED", label: "Expired", color: colors.error },
    { value: "OFFER_REJECTED", label: "Rejected", color: colors.error },
    {
      value: "PARTIAL_ACCEPTED",
      label: "Partial Accepted",
      color: colors.success,
    },
    {
      value: "PARTIAL_REJECTED",
      label: "Partial Rejected",
      color: colors.error,
    },
  ];

  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      height: "50px",
      p: "15px 18px",
      color: "#000000",
      fontWeight: 400,
      display: "flex",
      width: "200px",
      fontsize: "14px",
      lineHeight: "20px",
      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
      alignItems: "center",
      borderRadius: "30px",
      justifyContent: "space-between",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: " #000000",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      fontWeight: 600,
      color: "#333",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: "#333",
        fontWeight: isSelected ? 600 : 400,
        backgroundColor: "white",
        fontSize: "18px",
        lineHeight: "20px",
        mixBlendMode: "normal",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  const handleTypeSelect = (e) => {
    setSortBy(e.value);
    setPage(1);
  };

  return (
    <Grid item xs={12}>
      <Select
        styles={style}
        options={options}
        onChange={handleTypeSelect}
        isSearchable={false}
        components={{
          IndicatorSeparator: () => null,
        }}
        value={options.filter(function (option) {
          return option.value === sortBy;
        })}
      />
    </Grid>
  );
}
